// Schema.org Structured Data for Glow Lawns
// Add this to your pages for better SEO

export const schemaOrgData = {
  // LocalBusiness & Resort Schema
  localBusiness: {
    "@context": "https://schema.org",
    "@type": ["Resort", "LodgingBusiness", "TouristAttraction"],
    "name": "Glow Lawns",
    "alternateName": "Glow Lawns Moonrise Valley",
    "description": "Peaceful tree house resort in Chappanthottam, Kavilumpara, Kerala. Experience forest stays, private waterfall, fresh organic food & moonrise views.",
    "image": [
      "https://www.glowlawns.com/glowlawns-logo-transparent.png",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4",
      "https://images.unsplash.com/photo-1542718610-a1d656d1884c"
    ],
    "logo": "https://www.glowlawns.com/glowlawns-logo-transparent.png",
    "url": "https://www.glowlawns.com",
    "telephone": "+919995450101",
    "email": "info@glowlawns.com",
    "priceRange": "₹₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Thotillpalam, Chappanthottam",
      "addressLocality": "Kavilumpara",
      "postalCode": "673513",
      "addressRegion": "Kerala",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "11.9416",
      "longitude": "75.9349"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "sameAs": [
      "https://www.facebook.com/glowlawns",
      "https://www.instagram.com/glowlawns"
    ],
    "amenityFeature": [
      {
        "@type": "LocationFeatureSpecification",
        "name": "Private Waterfall Access",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Organic Restaurant",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "WiFi",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Parking",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Eco-friendly",
        "value": true
      }
    ],
    "starRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "120",
      "bestRating": "5",
      "worstRating": "1"
    }
  },

  // Breadcrumb Schema (for interior pages)
  breadcrumb: (pageName, pageUrl) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.glowlawns.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": pageName,
        "item": pageUrl
      }
    ]
  }),

  // Review Schema (for Reviews page)
  reviewSchema: (review) => ({
    "@context": "https://schema.org",
    "@type": "Review",
    "itemReviewed": {
      "@type": "Resort",
      "name": "Glow Lawns"
    },
    "author": {
      "@type": "Person",
      "name": review.name
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": review.rating,
      "bestRating": "5"
    },
    "reviewBody": review.text,
    "datePublished": review.date
  }),

  // Accommodation Schema (for Stay page)
  accommodation: (unit) => ({
    "@context": "https://schema.org",
    "@type": "Accommodation",
    "name": unit.name,
    "description": unit.description,
    "image": unit.images,
    "offers": {
      "@type": "Offer",
      "price": unit.price,
      "priceCurrency": "INR",
      "availability": unit.available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
    },
    "occupancy": {
      "@type": "QuantitativeValue",
      "maxValue": unit.capacity
    },
    "amenityFeature": unit.amenities.map(amenity => ({
      "@type": "LocationFeatureSpecification",
      "name": amenity,
      "value": true
    }))
  })
};

// Helper function to inject schema into page
export const injectSchema = (schemaData) => {
  if (typeof window !== 'undefined') {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);
  }
};

export default schemaOrgData;
